// Libraries
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
// Components
import { Fallback } from './Components';
// Types
import { ErrorBoundaryProps } from './ErrorBoundary.type';

/**
 * An error boundary component that catches and handles errors within its children components.
 *
 * @component
 * @param {ErrorBoundaryProps} props - The props for the ErrorBoundary component.
 * @returns {ReactElement} The rendered ErrorBoundary component.
 */
export const ErrorBoundary = (props: ErrorBoundaryProps) => {
  const { children, ...rest } = props;

  return (
    <ReactErrorBoundary fallbackRender={(errorProps) => <Fallback {...errorProps} {...rest} />}>
      {children}
    </ReactErrorBoundary>
  );
};
